import styles from '../../ItemPage.module.scss';
import { SectionHeading } from '../SectionHeading';

interface ItemPageSectionProps {
  children: React.ReactNode;
  id: string;
  heading?: string;
  ariaLabel?: string;
}

export const ItemPageSection: React.FC<ItemPageSectionProps> = ({
  children,
  id,
  heading,
  ariaLabel,
}) => {
  const headingId = `${id}-heading`;

  return (
    <section
      className={styles.section}
      id={id}
      aria-labelledby={heading ? headingId : undefined}
      aria-label={ariaLabel}
    >
      {heading && <SectionHeading id={headingId}>{heading}</SectionHeading>}
      {children}
    </section>
  );
};
